import React from "react";
import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";

const PublishBottomSheet = ({
  isOpen,
  onClose,
  onPublish,
  isPublishing,
  accounts,
  selectedAccount,
  onSelectAccount,
  isLinkedInConnected,
  onOpenAccountModal,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black-900 bg-opacity-50 md:backdrop-blur-sm flex items-end md:items-center justify-center z-50">
      <div className="bg-white rounded-t-2xl w-full p-6 max-h-[80vh] overflow-y-auto md:rounded-2xl md:max-w-sm md:mx-4 md:shadow-xl">
        <div className="flex justify-between items-center mb-4">
          <span className="font-bold text-lg text-black-800">
            {t("publish.toLinkedIn")}
          </span>
          <button onClick={onClose}>
            <span className="text-black-600 text-xl font-bold">✕</span>
          </button>
        </div>

        {!isLinkedInConnected ? (
          <button
            onClick={() => { onClose(); onOpenAccountModal(); }}
            className="flex items-center justify-center gap-2 w-full px-4 p-2 border-2 border-black-800 rounded-lg font-bold text-black-800 hover:bg-black-20 focus:outline-none focus:ring-2 focus:ring-primary-400 mb-3 !text-lg md:!text-md"
          >
            {t("buttons.connectLinkedIn")}
          </button>
        ) : (
          <div className="relative mb-3">
            <select
              value={selectedAccount || ""}
              onChange={(e) => onSelectAccount(e.target.value)}
              className="w-full px-4 py-2 border-2 border-black-800 rounded-lg text-base text-black-800 appearance-none bg-white focus:outline-none focus:ring-2 focus:ring-primary-400"
            >
              <option value="" disabled>
                {t("publish.selectAccount")}
              </option>
              {accounts.map((account) => (
                <option key={account.target} value={account.target}>
                  {account.label}
                </option>
              ))}
            </select>
            <ChevronDown className="absolute right-4 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none text-black-800" />
          </div>
        )}

        <button
          onClick={onPublish}
          disabled={!isLinkedInConnected || isPublishing || !selectedAccount}
          className="flex items-center justify-center gap-2 w-full px-4 py-2 bg-primary-400 hover:bg-primary-600 !text-lg font-bold md:!text-md text-black-900 border-2 !border-primary-400 hover:!border-primary-600 rounded-lg transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-primary-400 mb-3"
        >
          {isPublishing ? t("publish.publishing") : t("navbar.publish")}
        </button>

        <button
          onClick={onClose}
          className="flex items-center justify-center gap-2 w-full px-4 py-2 border-2 border-black-200 rounded-lg font-bold !text-lg md:!text-md text-black-600 hover:bg-black-20 focus:outline-none focus:ring-2 focus:ring-primary-400"
        >
          {t("buttons.cancel")}
        </button>
      </div>
    </div>
  );
};

export default PublishBottomSheet;